export default {

    userProperties({ userProperties }) {
        return userProperties;
    },

    tenantProperties({ tenantProperties }) {
        return tenantProperties;
    },
    conversationProperties({ conversationProperties }) {
        return conversationProperties
    },
    agentList({ agentList }) {
        return agentList;
    },

    activeAgentList({activeAgents}) {
        return activeAgents;
    },
    selectedConversation({ selectedConversation }) {
        return selectedConversation
    },


    teams({ teams }) {
        return teams
    },

    teamsAndUsers({ teamsAndUsers }) {
        return teamsAndUsers 
    },

    getMembersOfATeam({ teamsAndUsers, agentList}) {
        return (teamId) => {
            if(teamId === 'all')
                return agentList;
            let teamMates = {};
            teamsAndUsers.forEach((member) => {
                if(member.teamId === teamId && agentList[member.userId])
                    teamMates[member.userId] = agentList[member.userId];
                
            })
            return teamMates;
        }

    },

    allAssignee ({teams, agentList}) {
        let assignee = []
        Object.keys(teams).forEach(key => {
            const team = teams[key]
            assignee.push({
                id: team.teamId,
                name: team.name,
                isTeam: true
            })
        })

        Object.keys(agentList).forEach(key => {
            const user = agentList[key]
            assignee.push({
                id: user.id,
                name: user.firstName,
                fullName: user.firstName +" "+ user.lastName,
                isTeam: false,
                imageURL: user.imageURL,
                initial: user.firstName, 
                email: user.email
            })
        })
        return assignee
    },

    getUserAndTeam ({teams, teamsAndUsers, agentList}) {
        let teamsUsr = []
    
        Array.prototype.groupBy = function(prop) {
          return this.reduce(function(groups, item) {
            const val = item[prop]
            groups[val] = groups[val] || []
            groups[val].push(item)
            return groups
          }, {})
        }
        teamsAndUsers.forEach(teamUser => {
            if(agentList[teamUser.userId]){
                teamsUsr.push(
                    {
                        ...teamUser,
                        ...agentList[teamUser.userId]
                    }
                )
            }
    
        })
        let members = teamsUsr.groupBy('teamId')
        let finalteam = []
        Object.keys(teams).forEach(teamId => {
            
            finalteam.push({
                type: 'team',
                id: teamId,
                teamName: teams[teamId].name,
                members:members[teamId]
            })
        })
        let e= []
        Object.keys(agentList).forEach(w => {
            e.push({ 
                type:'assignee',
                ...agentList[w]
            })
        })
        return finalteam.concat(e)
    },
    scenarioList({scenarioList}) {
        return scenarioList;
	},

    orders({orders}) {
        return orders;
    },

    personId({personId}) {
        return personId;
    },

    customerProperties({customerProperties}) {
        return customerProperties;
    },
    scenarioPeopleProperties({ scenarioPeopleProperties }) {
        return scenarioPeopleProperties;
    },

    scenarioConversationProperties({ scenarioConversationProperties }) {
        return scenarioConversationProperties;
    },

    loadersInLoginScreen({ loginScreenStore }) {
        return (actionName) => {
            return loginScreenStore.meta.loaders[actionName]
        }
    },

    errorsInLoginScreen({ loginScreenStore }) {
        return (actionName) => {
            return loginScreenStore.meta.errors[actionName]
        }
    },

    getOrderShipmentDetails({ orderShipmentMap }) {
        return orderShipmentMap
    },

    customerEmail({ customerProperties, userProperties  }){
        return userProperties.email || customerProperties.email || ''
    }
}
